module.exports = __webpack_public_path__ + "img/concern@2x.6a07d71.webp";